





import Vue from 'vue'

export default Vue.extend({
  name: 'AssignedCellRenderer',

  computed: {
    icon (): string {
      // @ts-ignore
      return this.params.data.assigned ? 'check' : 'clear'
    },

    color (): string {
      // @ts-ignore
      return this.params.data.assigned ? 'green' : 'red'
    }
  }
})
